import { render, staticRenderFns } from "./LoadShape.vue?vue&type=template&id=87978c20&scoped=true&"
import script from "./LoadShape.vue?vue&type=script&lang=js&"
export * from "./LoadShape.vue?vue&type=script&lang=js&"
import style0 from "./LoadShape.vue?vue&type=style&index=0&id=87978c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87978c20",
  null
  
)

export default component.exports